import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["wrapper", "template", "addButton", "destroyCheckbox"]
  static values = { wrapperSelector: String }

  connect() {
    this.projectCount = this.wrapperTargets.length
  }

  addProject(event) {
    event.preventDefault()

    const template = this.templateTarget.innerHTML
    const timestamp = new Date().getTime()
    const newFields = template.replace(/NEW_RECORD/g, timestamp)

    // プロジェクト追加ボタンの前に新しいフィールドを挿入
    this.addButtonTarget.closest("div").insertAdjacentHTML("beforebegin", newFields)

    this.projectCount++
    this.updateProjectLabels()
  }

  removeProject(event) {
    event.preventDefault()

    const wrapper = event.target.closest(this.wrapperSelectorValue)

    if (wrapper) {
      // 既存のレコードの場合は_destroyをtrueにして非表示
      const destroyCheckbox = wrapper.querySelector('[data-nested-form-target="destroyCheckbox"]')
      if (destroyCheckbox) {
        destroyCheckbox.checked = true
        wrapper.style.display = "none"
      } else {
        // 新規レコードの場合はDOMから削除
        wrapper.remove()
      }

      this.projectCount--
      this.updateProjectLabels()
    }
  }

  updateProjectLabels() {
    const visibleWrappers = this.wrapperTargets.filter(
      wrapper => wrapper.style.display !== "none"
    )

    visibleWrappers.forEach((wrapper, index) => {
      const label = wrapper.querySelector("label")
      if (label && label.textContent.includes("プロジェクト")) {
        label.textContent = `プロジェクト${index + 1}`
      }
    })
  }
}
